package com.devi3east.bashbuddy.features.events.common.data.models

import com.devi3east.bashbuddy.common.domain.models.Address
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Event(
    val _id: String,
    val title: String? = null,
    val description: String? = null,
    val startInstant: Instant? = null,
    val endInstant: Instant? = null,
    val address: Address? = null,
    val createdAtInstant: Instant? = null,
    val createdById: String,
    val createdByName: String,
    val status: EventStatus = EventStatus.DRAFT,
    val publishedAtInstant: Instant? = null,
    val eventType: EventType,
    val featureStartInstant: Instant? = null,
    val featureEndInstant: Instant? = null,
    val isMultiDay: Boolean = false,
    val isLive: Boolean = false,
    val imageUrl: String? = null,
    var ticketsSold: Int = 0,
    var revenue: Long = 0L,
    var fiftyFiftyJackpot: Long = 0L,
    var favoriteCount: Int = 0,
    var viewsCount: Int = 0,
    val attendanceAge: Int? = null,
    val slug: String,
)